<template>
    <div class="container">
        <div class="row">
            <heading>
                {{ $t('savedData.types.pickupAddress') }}
            </heading>
        </div>
        <div class="row">
            <Card class="col-12">
                <LGTInput
                    :label="$t('booking.fields.name')"
                    v-model="data.name"
                    error-key="name"
                    :errors="errors"
                    required
                ></LGTInput>
                <div class="form-group">
                    <address-search-input
                        v-model="data.address"
                        :label="$t('booking.fields.address')"
                        @details="addressChanged"
                        :required="true"
                    ></address-search-input>
                    <small class="text-danger" v-if="errors['address']">{{ errors['address'][0] }}</small>
                </div>
                <div class="form-group">
                    <label class="">{{ $t('booking.fields.country') }}
                        <required-icon></required-icon>
                    </label>
                    <multiselect
                        v-model="data.country"
                        track-by="code"
                        label="name"
                        :options="countries"
                        :placeholder="$t('third_party.multiselect.placeholder')"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                    >
                        <template v-slot:noOptions>
                            {{ $t('third_party.multiselect.noOptions') }}
                        </template>
                    </multiselect>
                    <small class="text-danger" v-if="errors['country']">{{ errors['country'][0] }}</small>
                </div>
                <LGTInput
                    :label="$t('booking.fields.postal_code')"
                    v-model="data.postal_code"
                    error-key="postal_code"
                    :errors="errors"
                    required
                ></LGTInput>
                <LGTInput
                    :label="$t('booking.fields.city')"
                    v-model="data.city"
                    error-key="city"
                    :errors="errors"
                    required
                ></LGTInput>
                <div class="col-12 pr-0 my-3 text-right">
                    <button class="btn btn-primary" @click="store" v-if="data.id === undefined">{{ $t('savedData.actions.storePickupAddress') }}</button>
                    <button class="btn btn-primary" @click="store" v-else>{{ $t('savedData.actions.updatePickupAddress') }}</button>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>

import Card from '@/Components/Card'
import LGTInput from '@/Components/LGTInput'
import AddressSearchInput from '@/Components/AddressSearchInput'
import { cloneDeep } from 'lodash'
import { objectToFormData } from 'object-to-formdata'
export default {
    name: 'SavedPickupAddressCreadit',
    components: {Card, LGTInput,AddressSearchInput},
    data: () => {
        return {
            isStoring: false,
            errors: {},
            countries: lgt.countries,
            data: {
                name: null,
                address: null,
                postal_code: null,
                city: null,
                country: null,
            }
        }
    },
    methods: {
        addressChanged (val) {
            if(val.name !== ''){
                this.data.name = val.name
            }
            this.data.address = val.address
            this.data.postal_code = val.zipCode ?? val.postal_code
            this.data.city = val.city
            this.data.email = val.email
            this.data.country = this.countries.find((x) => x.code === val.countryShort)
        },
        store () {
            if(this.isStoring){
                return;
            }
            this.isStoring = true;

            const formData = objectToFormData(
                this.data,
                {
                    indices: true,
                    booleansAsIntegers: true,
                },
            )
            let url = '/saved-data/pickup-address';
            if(this.data.id !== undefined){
                url = '/saved-data/pickup-address/' + this.data.id;
            }
            axios.post(url, formData).then((response) => {
                window.location.href = '/saved-data/pickup-address?success'
            }).catch((err) => {
                this.isStoring = false;
                this.errors = err.response.data.errors
            })
        },
    },
    created () {
        if(lgt.hasOwnProperty('address')){
            this.data = lgt.address;
            this.data.country = this.countries.find((x) => x.code === this.data.country)

        }
    }
}
</script>
